import React from 'react'
import Catalogs from '../../../components/Common/Catalogs/Catalogs'
import useFetchList from '../../../elements/Hooks/useFetchList'
import { isEmpty } from 'lodash'
import useSelectionTable from '../../../elements/Hooks/useSelectionTable'
import useSubmit from '../../../elements/Hooks/useSubmit'
import { CatalogsApi } from '../../../api/Catalogs'
import useModalData from '../../../elements/Hooks/useModalData'

function CatalogsCont(props) {
  const { member } = props
  const [removingLine, rmLine] = useSubmit(CatalogsApi.lines.remove)
  const { list, fetch, fetching } = useFetchList(
    () => CatalogsApi.products(member._key),
    [member._key],
    isEmpty(member._key)
  )
  const removeLine = React.useCallback(
    async (line) => {
      await rmLine(line)
      await fetch()
    },
    [member._key]
  )
  const [expanded, setExpanded] = React.useState({})
  const {
    tableRef,
    selection,
    selectAll,
    setSelection,
    toggleSelection,
    toggleAll,
    isSelected,
  } = useSelectionTable()
  const [merging, merge] = useSubmit(() => CatalogsApi.mergeProducts(selection))

  async function mergeLines() {
    const updated = await merge()
    if (updated) {
      fetch()
      setSelection([])
    }
  }

  const {
    visible,
    modalType,
    object: catalog,
    setObject,
    submitting,
    removing,
    setRemoving,
    setSubmitting,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
    submit,
    remove,
    isNew,
  } = useModalData(CatalogsApi.create, CatalogsApi.update, CatalogsApi.remove, fetch)

  return (
    <Catalogs
      {...{
        list,
        fetch,
        fetching,
        tableRef,
        selection,
        selectAll,
        setSelection,
        toggleSelection,
        toggleAll,
        isSelected,
        merging,
        merge,
        mergeLines,
        visible,
        modalType,
        catalog,
        setObject,
        submitting,
        removing,
        setRemoving,
        setSubmitting,
        formRef,
        onShow,
        onCancel,
        checkForm,
        update,
        submit,
        remove,
        isNew,
        removingLine,
        removeLine,
        expanded,
        setExpanded,
      }}
    />
  )
}

export default CatalogsCont
